import {
  AUTH_REQUEST, AUTH_LOGOUT, AUTH_SUCCESS, AUTH_FAILURE, AUTH_TOKEN,
} from '../constants/auth.constants';

export const loginAction = (login, password, dominio) => ({
  type: AUTH_REQUEST,
  payload: { login, password, dominio },
});

export const authSuccessAction = (token, user, permisos) => ({
  type: AUTH_SUCCESS,
  payload: { token, user, permisos },
});

export const authFailureAction = error => ({
  type: AUTH_FAILURE,
  payload: error,
});

export const logoutAction = () => ({
  type: AUTH_LOGOUT,
});

export const setToken = token => ({
  type: AUTH_TOKEN,
  payload: {
    token,
  },
});
